import api from '@/api'

const { $student, $core, $email } = api;

export const { $processings } = $core;
export const { $students, $studentProcessing, $studentByIdentification, $generateDuesAccount } = $student;
export const { $notifications } = $email;
